export default __webpack_public_path__ + "static/media/pattern.fef7add7.png";